import { Component, OnInit, output, input, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApContentService, ApContentPipe, ApContentComponent } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApPincodeInputComponent } from '@ap/input/pincode';

import { ApSubmitComponent } from '../../../submit/submit.component';

import content from './pincode.content.json';

@Component({
    selector: 'ap-browser-pincode',
    templateUrl: './pincode.component.html',
    styleUrls: ['./pincode.component.scss'],
    imports: [
        ApPincodeInputComponent,
        FormsModule,
        ReactiveFormsModule,
        ApButtonComponent,
        ApContentComponent,
        ApSubmitComponent,
        ApContentPipe
    ]
})
export class ApBrowserPincodeComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - Text to show on submit button
     */
    public readonly submitText = input.required<string>();

    /**
     * Required - Control on which to save value of pincode
     */
    public readonly pincodeControl = input.required<FormControl<string>>();

    /**
     * Text to show on cancel button
     */
    public readonly cancelText = input<string>(undefined);

    /**
     * Can the user sign?
     * Defaults to false
     */
    public readonly canSign = input(false);

    /**
     * Show button if user has forgotten credentials.
     * Defaults to false
     */
    public readonly showLostCredentials = input(false);

    /**
     * Emits event when sign process is cancelled
     */
    /* eslint-disable @angular-eslint/no-output-native */
    public cancel = output<void>();
    public lostCredentials = output<void>();
    public submitted = output<void>();

    public errors: ErrorMessages;

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.errors = {
            required: this.contentService.get(`browser.pincode.error.required`),
            minlength: this.contentService.get(`browser.pincode.error.minlength`)
        };
    }
}
